import React, {useState} from 'react'

const ImagesView = ({data}) => {
  const [activeImg, setActiveImg] = useState(data.main_image_url)
  const tmpImages = [data.main_image_url, 'http://via.placeholder.com/402x402', 'http://via.placeholder.com/403x403', 'http://via.placeholder.com/404x404']

  return (
    <div className='imagesView'>
      <div className='imagesView-selector'>
        {tmpImages.map(e => (
          <div key={e} onClick={_ => setActiveImg(e)} style={{backgroundImage: `url('${e}')`}} className={e === activeImg ? 'imagesView-imgSelected' : ''}/>
        ))}
      </div>
      <div style={{backgroundImage: `url('${activeImg}')`}} className='imagesView-main'/>
    </div>
  )
}

export default ImagesView
